<ng-content>
    @if (title(); as title) {
        <h2 class="vds-dialog-header-title">{{ title }}</h2>
    }
</ng-content>
@if (!disableClose) {
    <button
        class="vds-dialog-header-close-button"
        vds-icon-button
        appearance="default"
        [ariaLabel]="closeLabel()"
        [vdsDialogClose]="dialogResult()"
    >
        <vds-icon name="close-large" class="vds-dialog-header-close-button-icon" />
    </button>
}
